import { defineStore } from 'pinia'

export interface TimerState {
  time: string,
  showCountdown: boolean
}

const initialState = (): TimerState => ({
  time: '0.0',
  showCountdown: false
})

export const timeState = defineStore('timeState', {
  state: initialState
})
